export default __webpack_public_path__ + "static/media/Farming-info-light.adb4f364.png";